/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: mojmir.studenovsky@eurowag.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum UnitCodeFluids {
    Litre = 'litre'
}

export function UnitCodeFluidsFromJSON(json: any): UnitCodeFluids {
    return UnitCodeFluidsFromJSONTyped(json, false);
}

export function UnitCodeFluidsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitCodeFluids {
    return json as UnitCodeFluids;
}

export function UnitCodeFluidsToJSON(value?: UnitCodeFluids | null): any {
    return value as any;
}

